import { Component, OnInit, inject } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { jsPDF } from 'jspdf';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FitService } from 'src/app/core/services/fit.service';
import { LoginService } from 'src/app/core/services/login.service';
import { TeamScopeService } from 'src/app/core/services/team-scope.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { Pagination, PaginationRequest, PaginationDynamoRequest, PaginationDynamoFiltersRequest, PaginationDynamoFiltersDateRequest, DynamoPage } from 'src/app/core/models/pagination.model';
import { Fit } from 'src/app/core/models/fit.model';
import { User } from 'src/app/core/models/user.model';
import { environment } from 'src/environments/environment';
import * as utils from 'src/app/shared/helpers/utils';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { PaginationService } from 'src/app/core/services/pagination.service';
import { formatDate } from '@angular/common';
import { Entity } from 'src/app/core/models/entity.model';
import { EntityService } from 'src/app/core/services/entity.service';
import { Settings360Depict } from 'src/app/core/models/settings.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { fontsList } from 'src/assets/fonts/fonts';

@Component({
  selector: 'hbo-fit-list',
  templateUrl: './fit-list.component.html',
  styleUrls: ['./fit-list.component.scss']
})
export class FitListComponent implements OnInit {

  madeForYouImageUrl = environment.apiMadeForYouUrl + '/backoffice/tags/img/';

  fits$ = new Observable<Pagination<Fit>>;

  user: User = utils?.localStorageGetItem('user');


  measures: { [key: string | number]: any } = {};
  //measures$ = of(this.measures);

  prevDynamoKey!: string;
  lastDynamoKey!: string;

  entities_filter!: Entity[];
  types_filter!: Array<{ value: string; label: string }>;

  fullLastDynamoKey!: string;

  fitLabelsMapping: any = {
    "shop": "shop_id",
    "fitId": "code_measure",
    "internalReference": "internalRef",
    "fitDateLocal": "date",
    "fitDateUTC": "date",
    "status": "finished"
  }

  columns: string[] = ['shop', 'fitId', 'internalReference', 'fitDateLocal', 'fitDateUTC', 'status']

  depictAvailable: boolean = false;
  ancestorData: any;
  hardDeleteNotificationError: string = 'false';

  //regular progress entities progressive loading
  /*phases: number = 0;
  phasesCompleted: number = 0;
  errorLoading = false;
  totalEntities: string = '';
  finalEntities!: Entity[];*/

  entitiesByPage: number = 10000;
  private spinner: HTMLElement;

  private readonly teamScope = inject(TeamScopeService);

  constructor(
    private configSvc: ConfigService,
    private ddbbUtils: DdbbUtils,
    public translateService: TranslateService,
    private fitService: FitService,
    private loginService: LoginService,
    private settingsService: SettingsService,
    public dynamoPaginationService: PaginationService,
    private entityService: EntityService,
    private router: Router,
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
    this.spinner = document.querySelector('hbo-loading') as HTMLElement;
    //fit requieres the own user entity to be in the list of childEntities to set filter entities payload
  }

  ngOnInit() {
    this.dynamoPaginationService.resetGazeMapPagination();
    this.dynamoPaginationService.resetFitPagination();
    this.ancestorData =  this.configSvc.currentConfigValue.userEntity?.parentEntity;
    //this.searchFits();
    /*this.phases = 0;
    this.phasesCompleted = 0;
    this.totalEntities = '';*/
    this.entitiesByPage = Number(utils.localStorageGetItem('entitiesByPage')) || this.entitiesByPage;
    //this.getEntitiesByPages(this.user.entityId, 1, this.entitiesByPage);
    this.fitService.currentFitConfigValue.pagination
      ? this.searchFit(this.fitService.currentFitConfigValue.pagination)
      : null;
    let storageFitFilter = JSON.parse(localStorage.getItem('fitFilter')!) as PaginationDynamoRequest
    storageFitFilter
      ? (
        this.fitService.setCurrentFitParamConfig('pagination', storageFitFilter),
        this.searchFit(storageFitFilter)
      )
      : this.searchFit();
  }

  searchFit(pagination?: PaginationDynamoRequest) {
    //columns by role
    //columns by role
    this.user.roleId == 4
      ? this.columns = ['fitId', 'internalReference', 'fitDateLocal', 'status']
      : this.columns = ['crossShopId', 'shop', 'fitId', 'internalReference', 'fitDateLocal', 'fitDateUTC', 'status'];
    this.loginService.userStore.subscribe(user => {
      user.childEntities = this.user.childEntities;
      this.entities_filter = user.childEntities!.filter(entity => entity.entityTypeId == 4);
      this.types_filter = [
        {value:'pending', label:'COMMON.PENDING'},
        {value:'finished', label:'COMMON.FINISHED'}
      ];
      let queryStringParams: PaginationDynamoRequest = {};
      let queryStringParamsArray: any[] = [];
      queryStringParams.role = this.user.role?.id == 4 ? 'shop' : this.user.role?.id == 2 ? 'distributor' : this.user.role?.id == 3 ? 'distributor' : 'admin';
      queryStringParams.per_page = pagination?.perPage || 10;
      queryStringParams.entity_id = this.user.role?.id == 3 ? this.ancestorData.internalCode ? String(this.ancestorData.internalCode) : String(this.ancestorData.id) : String(this.user.entity.internalCode);
      ///determine usin prev, last and reverse keys
      !pagination?.dynamoReverse
        ? pagination?.dynamoLastKey
          ? queryStringParams.last_key = pagination?.dynamoLastKey
          : null
        : pagination?.dynamoPrevKey && pagination?.page! > 1
          ? queryStringParams.last_key = pagination?.dynamoPrevKey
          : null;
      !pagination?.dynamoReverse
        ? queryStringParams.reverse_search = false
        : pagination?.page! > 1 || pagination?.page! < 0
          ? queryStringParams.reverse_search = pagination?.dynamoReverse
          : null;
      let filters: PaginationDynamoFiltersRequest = {};
      let date: PaginationDynamoFiltersDateRequest = {};
      //dates
      pagination?.filter_params
        ? pagination.filter_params!['entities'] = this.fitService.currentFitConfigValue.shops_selected
        : null;
      /*let partners: string;
      pagination?.filter_params && pagination?.filter_params!['entities'] && pagination?.filter_params!['entities'].length
        ? partners = pagination.filter_params!['entities'].map((entity: { internalCode: string; id: number; }) => entity.internalCode ?? entity.id).join('+')
        : this.user.role?.id != 4
          ? partners = user.childEntities!.filter(entity => entity.entityTypeId == 4).map(entity => entity.internalCode ?? entity.id).join('+')
          : partners = `${user.entity.internalCode}`;
      !pagination?.filter_params || (pagination?.filter_params && !pagination?.filter_params!['entities'])
        ? this.user.roleId === 1 ? delete queryStringParams.shop_id : filters['shop_id'] = queryStringParams.shop_id = partners
        : queryStringParams.shop_id = partners;
      console.log(queryStringParams.shop_id);*/

      this.configSvc.currentConfigValue.fitsEntitiesSelectedApplied?.length
        ? queryStringParams.shop_id = this.configSvc.currentConfigValue.fitsEntitiesSelectedApplied?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.internalCode ?? entity.id).join('+')
        : this.user.roleId === 1 ?
          // role.id == 1
          this.user.horizonsTeamId == null ?
            delete queryStringParams.shop_id
            // if therere is a horizonsTeamId, filter by the element in combobox
            : queryStringParams.shop_id = this.entities_filter.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.internalCode ?? entity.id).join('+')
          : this.user.role?.id != 4
              ? this.user.role?.id != 2 ?
                queryStringParams.shop_id = this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.internalCode ?? entity.id).join('+'):
                // role.id == 2
                queryStringParams.shop_id = this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 4 && this.teamScope.isInScope(entity.teamId)).map((entity: Entity) => entity.internalCode ?? entity.id).join('+') 
              // role.id == 4                
              : queryStringParams.shop_id = `${user.entity.internalCode}`;
      //force to let development
      //queryStringParams.shop_id = 'CR-SURFACING';
      //queryStringParams.shop_id = 'prueba-2-optica-headoffice+prueba-3-optica-headoffice+OPTICA2A+OPTICA1A+OPTICA2B+Randstad 1+HEAD_OPTICA1A+Randstad 2+OPTICA1B+prueba-optica-headoffice';
      //queryStringParams.shop_id = 'OPTICA1A+OPTICA2B+OPTICA1B';//OPTICA2B OPTICA1B
      //queryStringParams.shop_id = '21';
      //queryStringParams.shop_id = 'OPTICA1A';

      if (pagination?.filter_params!) {
        filters.date = {};
        pagination?.filter_params!['startDate'] != ''
          ? filters.date.init = pagination?.filter_params!['startDate']
          : null;
        pagination?.filter_params!['endDate'] != ''
          ? filters.date.end = pagination?.filter_params!['endDate']
          : null;
        pagination?.filter_params!['type'] && pagination?.filter_params!['type'] != ''
          ? filters['finished'] = pagination?.filter_params!['type'] == 'finished' ? true : false
          : null;
        pagination?.filter_params!['deleted']
          ? filters['hidden'] = pagination?.filter_params!['deleted'] ? 'True' : 'False'
          : null;
      } else {
        const now = new Date();
        // Note: months are returned in 0-11 format instead of 1-12, that is why we add 1 before converting it to string
        let now_str = `${now.getUTCFullYear()}-${(now.getUTCMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2 })}-${now.getUTCDate()}`
        filters.date = { end: now_str };
        /*if (this.user.role?.id == 1) {
          filters.date.init = formatDate(new Date(new Date().getTime() - (60 * 60 * 24 * 7 * 1000)), 'yyyy-MM-dd', 'en')
        }*/
      }
      !filters.date.end && !filters.date.init
        ? delete filters.date
        : null;
      //delete filters.date;
      /*filters.date = date;
      filters.date!.end = "";
      filters.date!.init = "";*/
      pagination?.search_params ? queryStringParams.search_params = pagination?.search_params : null;
      pagination?.sort
        ? queryStringParams.sort = this.fitLabelsMapping[pagination?.sort]
        : null;
      pagination?.order
        ? queryStringParams.order = pagination?.order
        : null;
      //filters['shop_id'] = partners;
      //convert to base64 filter
      queryStringParams.filter_params = filters;
      pagination?.search_with_entity && (queryStringParams.search_entity = pagination.search_with_entity);
      if (!pagination?.search_params || pagination?.search_params == '') {
        delete queryStringParams.search_entity;
      }
      //const search_params = pagination?.search_with_entity ? pagination?.search_with_entity : pagination?.search_params;
      Object.entries(queryStringParams).map(elem => {
        elem[0] == 'filter_params'
          ? queryStringParamsArray.push(`${elem[0]}=${btoa(JSON.stringify(elem[1]))}`)
          : elem[0] == 'search_params'
            ? queryStringParamsArray.push(`${elem[0]}=${pagination?.search_params?.trim()}`)
            : queryStringParamsArray.push(`${elem[0]}=${elem[1]}`)
      });
      // let testBase64 = btoa(JSON.stringify(filters));
      this.fits$ = this.fitService.index2(queryStringParamsArray.join('&'))
      .pipe(
        catchError(error => {
          console.log('Error fetching fits:', error);
          return of({
            data: [],
            last_key: null,
            original_last_key: {},
            params: {}
          });
        }),        
        map(fits => ({
          total: fits.tag_list ? fits.tag_list.length: 0,
          perPage: pagination?.perPage || 10,
          currentPage: pagination?.page || 1,
          lastPage: 1,
          from: 1,
          to: fits.tag_list ? fits.tag_list.length: 0,
          data: fits.tag_list ? (pagination?.dynamoReverse ? fits.tag_list.reverse() : fits.tag_list) : [],
          dynamoLastKey: this.setPrevKey(pagination?.page, pagination?.sort || queryStringParams.sort, fits.tag_list ? fits.tag_list[0] : {}, fits.last_key, pagination!),
          dynamoPrevKey: pagination?.dynamoPrevKey || null,
          dynamoFullLastKey: fits.full_last_key || null,
          dynamoReverse: pagination?.dynamoReverse || false,
          sort: pagination?.sort || queryStringParams.sort,
          order: pagination?.order || queryStringParams.order,
          search_params: pagination?.search_params || queryStringParams.search_params,
          search_with_entity: pagination?.search_with_entity || queryStringParams.search_params,
          filter_params: pagination?.filter_params || queryStringParams.filter_params,
          showFilters: pagination?.showFilters || false,
          role: pagination?.role || queryStringParams.role,
          roleId: pagination?.roleId || this.user.role?.id,
          selectorEntitiesSearch: pagination?.selectorEntitiesSearch || ''
        }))
      );
    });
  }

  setPrevKey(_page: number = 1, _sort: string | undefined, _previous: Fit, _key: string, _pagination: PaginationRequest) {
    _pagination && _previous
      ? (
        this.prevDynamoKey = this.base64Previous(_sort, _previous),//clone
        this.lastDynamoKey = _key
      )
      : this.lastDynamoKey = _key
    let dynamoPage: DynamoPage = {
      page: _page,
      lastKey: _key,
      prevKey: this.prevDynamoKey,
      visible: true,
      hide: false
    }
    this.dynamoPaginationService.setCurrentFitDynamoPage(dynamoPage);
    return _key
  }
  base64Previous(_sort: string | undefined, _previous: Fit) {
    let previous: any = { "error_status_bool": 0.0, 'TagID': '', 'date': '' };
    previous.TagID = _previous.TagID;
    previous.date = _previous.date;
    _sort
      ? previous[_sort] = _previous[_sort]
      : null
    return btoa(JSON.stringify(previous))
  }

  persistanceFilters(_testId?: string) {
    this.fitService.currentFitConfigValue.pagination
      ? localStorage.setItem('FitFilter', JSON.stringify(this.fitService.currentFitConfigValue.pagination))
      : null;
    //this._location.go('/gaze-maps/' + _testId)
  }

  updateFitReference(fit: Fit) {
    this.fitService.updateReference(fit.TagID, fit.internalRef).subscribe();
  }

  updateFitComments(fit: Fit) {
    this.measures[fit.TagID].comments = fit.comments;
    this.fitService.updateComments(fit.TagID, fit.comments).subscribe();
  }

  getTar(fit: Fit) {
    this.fitService.tar(fit.TagID).subscribe(tar => window.open(tar.location, '_blank'));
  }

  goToInvision(fit: Fit) {
    this.fitService.openInvision(fit.TagID, this.user.role?.id === 1 ? true : false);
  }

  goTo360Depict(fit: Fit) {
    this.fitService.open360Depict(fit.TagID);
  }

  generateDataFile(fit: Fit) {
    const filename = fit.code_measure + '.vca';
    let content = '';

    content += 'IPD=' + this.measures[fit.TagID].Naso_R.toString() + ';' + this.measures[fit.TagID].Naso_L + '\n';
    content += 'SEGHT=' + this.measures[fit.TagID].HeightBOX_R + ';' + this.measures[fit.TagID].HeightBOX_L + '\n';
    if (this.measures[fit.TagID].HeightFrame_R) {
      content += 'SEGDHT=' + this.measures[fit.TagID].HeightFrame_R + ';' + this.measures[fit.TagID].HeightFrame_L + '\n';
    }
    content += 'BVD=' + this.measures[fit.TagID].BVD_R + ';' + this.measures[fit.TagID].BVD_L + '\n';
    content += 'PANTO=' + this.measures[fit.TagID].Panto + '\n';
    content += 'ZTILT=' + this.measures[fit.TagID].Tilt + '\n';
    content += 'HBOX=' + this.measures[fit.TagID].HBOX + '\n';
    content += 'VBOX=' + this.measures[fit.TagID].VBOX + '\n';
    content += 'DBL=' + this.measures[fit.TagID].DBL + '\n';
    if (this.measures[fit.TagID].Inset_R) {
      content += 'NPD=' + this.measures[fit.TagID].NearPD_R + ';' + this.measures[fit.TagID].NearPD_L + '\n';
      content += 'ERNRIN=' + this.measures[fit.TagID].Inset_R + ';' + this.measures[fit.TagID].Inset_L + '\n';
      content += "NWD=" + (this.measures[fit.TagID].NearDistance / 100).toFixed(2)
    }
    // if (this.measures[fit.TagID]?.Corridor) {
    //   content += 'CORRIDOR=' + this.measures[fit.TagID].Corridor + '\n';
    // }

    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();
    document.body.removeChild(element);
  }

  async generatePdf(fit: Fit) {
    const pdf = new jsPDF('l', 'mm', 'a4', true);
    //Load all fonts
    Object.entries(fontsList).forEach(([key, { font, name, type }]) => {
      pdf.addFileToVFS(key, font);
      pdf.addFont(key, name, type);
    });
    const shopData = await this.getShopData(fit.shop_id);
    const canvasWidth = pdf.internal.pageSize.getWidth();
    const canvasHeight = pdf.internal.pageSize.getHeight();
    let nLines = !this.measures[fit.TagID].HeightFrame_L ? 7 : 8;
    nLines = !this.measures[fit.TagID].Inset_R ? nLines : nLines+1;
    nLines = !this.measures[fit.TagID].Corridor? nLines : nLines+1;
    const lang = shopData['language'];
    const internalRef = fit.internalRef?.replace(/\n/g, ' ') ?? '';
    const logoHeight = this.convertPx2mm(38);

    const currentLang = this.translateService.currentLang;
    this.translateService.use(lang);

    // Add background Image
    const background = new Image();
    background.src = 'assets/images/fit-background.png';
    pdf.addImage(background, 'png', 10, 20, canvasWidth - 20, canvasHeight - 40, 'background', 'FAST');

    // Add left logo
    if (shopData['logoLeft']) {
      const logoLeftDimensions = await this.getImageDimensions(shopData['logoLeft']);
      const logoLeftWidth = this.convertPx2mm(this.calculateResizedWidth(logoLeftDimensions.w, logoLeftDimensions.h, 38));
      pdf.addImage(shopData['logoLeft'], 'png', 13, 23, logoLeftWidth, logoHeight, 'logo_left', 'FAST');
    }
    // Add right logo
    if (shopData['logoRight']) {
      const logoRightDimensions = await this.getImageDimensions(shopData['logoRight']);
      const logoRightWidth = this.convertPx2mm(this.calculateResizedWidth(logoRightDimensions.w, logoRightDimensions.h, 38));
      pdf.addImage(shopData['logoRight'], 'png', canvasWidth - 13 - logoRightWidth, 23, logoRightWidth, logoHeight, 'logo_right', 'FAST');
    }

    // Add user photo
    const userPhoto = this.measures[fit.TagID].img ?? '';
    pdf.addImage(userPhoto, 'jpeg', 122, 20, 50.7, 37, 'user_photo', 'FAST');

    // Code measure
    pdf.setFontSize(8.5);
    pdf.setTextColor(255, 255, 255);
    if (lang === 'th') {
      pdf.setFont('THSarabunNew', 'normal');
    } else {
      pdf.setFont('Lato-Light', 'bold');
    }
    pdf.text(`${this.translateService.instant('FIT.CODE_MEASURE')}:   ${fit.code_measure}`, canvasWidth - 15, 55, { align: 'right' });

    // Draw table lines and results
    pdf.setDrawColor(255, 255, 255);
    pdf.setLineWidth(0.1);

    if (lang === 'th') {
      pdf.setFont('THSarabunNew', 'normal');
    } else {
      pdf.setFont('Lato-Light', 'bold');
    }
    const h_string_bold = 5.5 - (pdf.getTextDimensions('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPKRSTUVWXYZ()º').h / 2);
    const h_number = 5.5 - (pdf.getTextDimensions('0123456789').h / 2);

    // Draw table lines
    for (let x = 100; x <= (100 + nLines * 5.5); x += 5.5) {
      pdf.line(185, x, 278, x);
    }

    // Header results table
    const w_right = pdf.getTextDimensions(this.translateService.instant('FIT.RIGHT')).w / 2;
    const w_left = pdf.getTextDimensions(this.translateService.instant('FIT.LEFT')).w / 2;
    pdf.text(this.translateService.instant('FIT.RIGHT'), 240, 100 + h_string_bold, { align: 'center' });
    pdf.text(this.translateService.instant('FIT.LEFT'), 260, 100 + h_string_bold, { align: 'center' });

    if (lang === 'th') {
      pdf.setFont('THSarabunNew', 'normal');
    } else {
      pdf.setFont('Lato-Light', 'normal');
    }
    const h_string_normal = 5.5 - (pdf.getTextDimensions('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPKRSTUVWXYZ()º').h / 2);
    const height_vbd = !this.measures[fit.TagID].HeightFrame_L ? 100 + (3 * 5.5) : 100 + (4 * 5.5);

    // Text table results
    pdf.text(`${this.translateService.instant('FIT.INTERP_DIST')} (mm)`, 186, 100 + 5.5 + h_string_normal);
    pdf.text(`${this.translateService.instant('FIT.FITTING_HEIGHT_BOX')} (mm) ${this.translateService.instant('FIT.BOX')}`, 186, 100 + (5.5 * 2) + h_string_normal);
    if (this.measures[fit.TagID].HeightFrame_L) {
      pdf.text(`${this.translateService.instant('FIT.FITTING_HEIGHT_RIM')} (mm) ${this.translateService.instant('FIT.RIM')}`, 186, 100 + (3 * 5.5) + h_string_normal);
    }
    pdf.text(`${this.translateService.instant('FIT.VBD')} (mm)`, 186, height_vbd + h_string_normal);
    pdf.text(`${this.translateService.instant('FIT.PANTO')} (º)`, 186, height_vbd + (5.5) + h_string_normal);
    pdf.text(`${this.translateService.instant('FIT.WRAP')} (º)`, 186, height_vbd + (5.5 * 2) + h_string_normal);
    pdf.text('HBOX / VBOX / DBL (mm)', 186, height_vbd + (5.5 * 3) + h_string_normal);
    if (this.measures[fit.TagID].Inset_R) {
      pdf.text(`${this.translateService.instant('FIT.NEAR')} / ${this.translateService.instant('FIT.INSERT')} (mm) - ${this.measures[fit.TagID].NearDistance}cm`, 186, height_vbd + (5.5 * 4) + h_string_normal);
    }
    if (this.measures[fit.TagID].Corridor) {
      pdf.text(`${this.translateService.instant('FIT.CORRIDOR')} (mm)`, 186, height_vbd + (5.5 * 5) + h_string_normal);
    }
    const internalRef_spaceing = this.measures[fit.TagID].Inset_R? 6.5 : 4.5;
    pdf.text(`${this.translateService.instant('FIT.INTERNAL_REF').toUpperCase()}:`, 186, height_vbd + (internalRef_spaceing * 5.5) + h_string_normal);

    // Results table
    pdf.setFont('Lato-Light', 'bold');
    pdf.text(this.measures[fit.TagID].Naso_R, 240 + w_right, 100 + 5.5 + h_number, { align: 'center' }); // ipd left
    pdf.text(this.measures[fit.TagID].Naso_L, 260 + w_left, 100 + 5.5 + h_number, { align: 'center' }); // ipd right
    pdf.text(this.measures[fit.TagID].HeightBOX_R, 240 + w_right, 100 + (5.5 * 2) + h_number, { align: 'center' }); // box left
    pdf.text(this.measures[fit.TagID].HeightBOX_L, 260 + w_left, 100 + (5.5 * 2) + h_number, { align: 'center' }); // box right
    if (this.measures[fit.TagID].HeightFrame_L) {
      pdf.text(this.measures[fit.TagID].HeightFrame_R, 240 + w_right, 100 + (3 * 5.5) + h_number, { align: 'center' }); // RIM left
      pdf.text(this.measures[fit.TagID].HeightFrame_L, 260 + w_left, 100 + (3 * 5.5) + h_number, { align: 'center' }); // RIM right
    }
    pdf.text(this.measures[fit.TagID].BVD_R, 240 + w_right, height_vbd + h_number, { align: 'center' }); // VBD left
    pdf.text(this.measures[fit.TagID].BVD_L, 260 + w_left, height_vbd + h_number, { align: 'center' }); // VBD right
    pdf.text(this.measures[fit.TagID].Panto, 240 + ((260 + w_left - 240 + w_right) / 2), height_vbd + (5.5) + h_number, { align: 'center' }); // panto
    pdf.text(this.measures[fit.TagID].Tilt, 240 + ((260 + w_left - 240 + w_right) / 2), height_vbd + (5.5 * 2) + h_number, { align: 'center' }); // wrap
    pdf.text(`${this.measures[fit.TagID].HBOX} / ${this.measures[fit.TagID].VBOX} / ${this.measures[fit.TagID].DBL}`, 240 + ((260 + w_left - 240 + w_right) / 2), height_vbd + (5.5 * 3) + h_number, { align: 'center' }); // hbox / vbox / dbl
    if (this.measures[fit.TagID].Inset_R) {
      pdf.text(`${this.measures[fit.TagID].NearPD_R} / ${this.measures[fit.TagID].Inset_R}`, 240 + w_right, height_vbd + (5.5 * 4) + h_number, { align: 'center' }); // NearPD_R left
      pdf.text(`${this.measures[fit.TagID].NearPD_L} / ${this.measures[fit.TagID].Inset_L}`, 260 + w_left, height_vbd + (5.5 * 4) + h_number, { align: 'center' }); // NearPD_L right
    }
    if (this.measures[fit.TagID].Corridor) {
      pdf.text(this.measures[fit.TagID].Corridor, 240 + ((260 + w_left - 240 + w_right) / 2), height_vbd + (5.5*5) + h_number, { align: 'center' }); // Corridor
    }

    pdf.text(internalRef, 240 - w_right, height_vbd + (internalRef_spaceing * 5.5) + h_number, { align: 'left' });

    // Left image text
    if (lang === 'th') {
      pdf.setFont('THSarabunNew', 'normal');
    } else {
      pdf.setFont('Lato-Light', 'regular');
    }

    pdf.text(this.translateService.instant('FIT.WRAP').toUpperCase(), 231, 98, { align: 'center' });
    pdf.setFontSize(8);
    pdf.text(this.translateService.instant('FIT.RIGHT_EYE'), 167, 110, { align: 'left' });
    pdf.text(this.translateService.instant('FIT.LEFT_EYE'), 167, 117, { align: 'left' });

    // Results images
    pdf.setFont('Lato-Light', 'bold');

    // Left image top results
    pdf.setFontSize(8);
    pdf.text(this.measures[fit.TagID].Tilt + 'º', 281, 85);

    // Left image side results
    pdf.text(this.measures[fit.TagID].Panto + 'º', 156.5, 75, { align: 'center' });
    pdf.setFontSize(7);
    pdf.text(this.measures[fit.TagID].BVD_R, 167, 113, { align: 'left' });
    pdf.text(this.measures[fit.TagID].BVD_L, 167, 120, { align: 'left' });

    // Left image results
    pdf.setFontSize(8);
    pdf.text(this.measures[fit.TagID].VBOX, 21, 111, { align: 'right' });
    pdf.text(this.measures[fit.TagID].Naso_R, 58, 78, { align: 'center' });
    pdf.text(this.measures[fit.TagID].Naso_L, 74, 78, { align: 'center' });
    pdf.text(this.measures[fit.TagID].HBOX, 46, 143, { align: 'center' });
    pdf.text(this.measures[fit.TagID].DBL, 65, 143, { align: 'center' });
    pdf.text(this.measures[fit.TagID].HeightBOX_R, 40, 118, { align: 'center' });
    pdf.text(this.measures[fit.TagID].HeightBOX_L, 90, 118, { align: 'center' });

    pdf.save(fit.code_measure + '.pdf');
    this.translateService.use(currentLang);
  }

  getShopData(shopId: string): Promise<{ logoLeft: string, logoRight: string, language: string }> {
    const default_settings = {
      logoLeft: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
      logoRight: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
      language: 'en-GB',
    }
    return new Promise(async (resolve, reject) => {
      let entity = this.user.childEntities!.find(entity => shopId === String(entity.internalCode));
      entity = entity ? entity : this.user.entity
      if (entity) {
        await this.getFitSettings(entity).then(
          async (res: any) => {
            // Handle result
            if (res.appFrontendDesign.logo1.logoImage == '')
              res.appFrontendDesign.logo1.logoImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
            if (res.appFrontendDesign.logo2.logoImage == 'data:image/png;base64, c2k=')
              res.appFrontendDesign.logo2.logoImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
            if (res && Object.keys(res).length > 0) {
              resolve({
                logoLeft: res.appFrontendDesign.logo1.logoImage ? res.appFrontendDesign.logo1.logoImage : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mP8z8BQz0AEYBxVSF+FABJADveWkH6oAAAAAElFTkSuQmCC',
                logoRight: res.appFrontendDesign.logo2.logoImage ? res.appFrontendDesign.logo2.logoImage : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mNk+M9Qz0AEYBxVSF+FAAhKDveksOjmAAAAAElFTkSuQmCC',
                language: res.language,
              });
            }
          }, error => {
            console.log(error);
            resolve(default_settings);
          });
      } else {
        resolve(default_settings)
      }

      /*this.settingsService.get(entityId ?? user.entityId, 4).subscribe(
        async res => {
          // Handle result
          if (res && Object.keys(res).length > 0) {
            resolve({
              logoLeft: res.logo1.logoImage ? await this.settingsService.getBase64Image(res.logo1.logoImage) : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mP8z8BQz0AEYBxVSF+FABJADveWkH6oAAAAAElFTkSuQmCC',
              logoRight: res.logo2.logoImage ? await this.settingsService.getBase64Image(res.logo2.logoImage) : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mNk+M9Qz0AEYBxVSF+FAAhKDveksOjmAAAAAElFTkSuQmCC',
              language: res.language,
            });
          }
        },
        error => {
          resolve({
            logoLeft: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mP8z8BQz0AEYBxVSF+FABJADveWkH6oAAAAAElFTkSuQmCC',
            logoRight: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mNk+M9Qz0AEYBxVSF+FAAhKDveksOjmAAAAAElFTkSuQmCC',
            language: 'en-GB',
          });
        },
        () => {
          // 'onCompleted' callback.
          // No errors, route to new page here
        });*/

    });
  }

  // loadFonts() {
  //   const callAddFont = function () {
  //     Object.keys(fontsList).forEach(function (key: string) {
  //       this.addFileToVFS(key, fontsList[key].font);
  //       this.addFont(key, fontsList[key].name, fontsList[key].type);
  //     }.bind(this))
  //   }
  //   jsPDF.API.events.push(['addFonts', callAddFont]);
  // }

  convertPx2mm(dimension: number) {
    return dimension * 25.4 / 96;
  }

  calculateResizedWidth(originalWidth: number, originalHeight: number, resizedHeight: number) {
    return (resizedHeight * originalWidth) / originalHeight;
  }

  getImageDimensions(file: string): Promise<{ w: number, h: number }> {
    return new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve({ w: i.width, h: i.height });
      i.src = file;
    });
  }

  loadData(_fit: Fit) {
    //reverse shop_id to backoffice id and get parent Entity id
    let backoffice_entity: Entity = this.user.childEntities!.find(entity => _fit.shop_id === String(entity.internalCode))!;
    backoffice_entity = backoffice_entity ? backoffice_entity: this.user.entity

    if ((_fit as any).hard_deleted_at) {
      this.measures[_fit.TagID] = {
        ...this.measures[_fit.TagID],
        hard_deleted_at: (_fit as any).hard_deleted_at
      };
      this.spinner.style.display = 'none';
      return;
    }

    if (!this.measures[_fit.TagID]) {
      this.spinner.style.display = 'block';
      this.measures[_fit.TagID] = {};
      if (backoffice_entity) {
        this.checkLicense(backoffice_entity, _fit);
        this.checkHardDeletePermission(backoffice_entity, _fit);
      }
      this.fitService.indexData(_fit.TagID).subscribe(data => {
        if (data.fit_data.measures) {
          _fit.measures = data.fit_data.measures;
          _fit.workaround_version = data.fit_data.workaround_version;
          this.fitService.apply_workaround(_fit);
          const data_values_to_string: { [key: string]: any } = {};
          Object.keys(_fit.measures).forEach((key: string) => {
            data_values_to_string[key] = _fit.measures[key].toString();
          });
          this.measures[_fit.TagID] = { ...this.measures[_fit.TagID], ...data_values_to_string };
          // this.measures[_fit.TagID].img = _fit.img
        }
        this.measures[_fit.TagID].img = data.fit_data.img;
        this.measures[_fit.TagID].comments = data.fit_data.comments;
        if (data.fit_data.deleted_at){
          this.measures[_fit.TagID].deleted_at = data.fit_data.deleted_at;
        }
        if (data.fit_data.hard_deleted_at) {
          this.measures[_fit.TagID].hard_deleted_at = data.fit_data.hard_deleted_at;
        }
        _fit.comments = data.fit_data.comments;
        //distributor settings
        this.spinner.style.display = 'none';
      })
    } else {
      _fit.comments = this.measures[_fit.TagID].comments
      if (backoffice_entity && this.measures[_fit.TagID]?.canHardDelete === undefined) {
        this.checkHardDeletePermission(backoffice_entity, _fit);
      }
      this.spinner.style.display = 'none';
    }
  }

  private checkLicense(backoffice_entity: Entity, _fit: Fit) {
    this.entityService.getEntityApps(backoffice_entity.id).subscribe(res => {
      // The integrated experience is granted by a package that ships 360Depict alongside Fit.
      // Buying Fit and the standalone 360 Depict separately does not include it.
      this.depictAvailable = this.getDepicAvailable(res.bundledAppsIds ?? []);
      this.user.childEntities!.find(entity => _fit.shop_id === entity.name)?.parentEntityId!;
      if (this.depictAvailable) {
        this.measures[_fit.TagID].available = true;

        this.setSettingsAncestor(backoffice_entity.id).then(settings => {
          this.settingsService.getThickness(
            backoffice_entity.internalCode,
            settings.base64,
            4
          ).subscribe(thicknessRes => {
            this.measures[_fit.TagID].depictLogo = thicknessRes.appFrontendDesign?.['360Depict']?.logoImage;
          });
        });
      } else {
        this.measures[_fit.TagID].available = false;
      }
    });
  }

  private checkHardDeletePermission(backoffice_entity: Entity, _fit: Fit) {
    this.getFitSettings(backoffice_entity).then(
      (settings: any) => {
        this.measures[_fit.TagID].canHardDelete = settings?.dataProtection?.allowDelete === true;
        this.measures[_fit.TagID].opticalShopEmail = settings?.dataProtection?.opticalShopEmail ?? null;
      },
      (error) => {
        console.log('Error fetching settings for hard delete permission:', error);
        this.measures[_fit.TagID].canHardDelete = false;
        this.measures[_fit.TagID].opticalShopEmail = null;
      }
    );
  }

  getDepicAvailable(_apps: number[]): boolean {
    let appsIds: number[] = _apps;
    if (appsIds.includes(7)) {
      return true
    } else {
      return false
    }
  }

  async getFitSettings(entity?: Entity): Promise<any> {
    let SettingsAncestor = await this.setSettingsAncestor(entity?.id!);
    return new Promise(async (resolve, reject) => {
      //await this.settingsService.get(_internalCode!, _app, SettingsAncestor.base64).subscribe(
      await this.settingsService.getInvision(entity?.internalCode!, SettingsAncestor.base64, 4).subscribe(
        res => {
          resolve(res)
        },
        err => {
          reject(err)
        });
    });
  }

  setSettingsAncestor(_id: number): Promise<{ data: any; base64: string }> {
    let entityToSettings = this.user.childEntities!.find((entity: Entity) => entity.id === _id)!;
    entityToSettings = entityToSettings ? entityToSettings : this.user.entity
    return new Promise(async (resolve, reject) => {
      await this.entityService.getAncestor(entityToSettings).subscribe(
        async res => {
          let parentEntity = res.parentEntity;
          let object = {
            "hierarchy": {
              "shop_id": String(entityToSettings.internalCode ? entityToSettings.internalCode : entityToSettings.id),
              "ancestor": {
                "shop_id": String(parentEntity?.internalCode ? parentEntity?.internalCode : parentEntity?.id),
                "ancestor": entityToSettings?.entityTypeId != 2
                  ? {
                    "shop_id": String(parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.id),
                    "ancestor": parentEntity?.parentEntity?.entityTypeId == 2
                      ? {
                        "shop_id": String(parentEntity?.parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.parentEntity?.id),
                        "ancestor": null
                      }
                      : null
                  }
                  : null
              }
            }
          }
          resolve({ data: object, base64: utils.objectToBase64(object) });
          //resolve({ data: object, base64: utils.objectToBase64(object) });
        },
        err => {
          reject(err)
        });
    });
  }

  setCrossShop = (_shopId: string) => {
    return this.user.childEntities!.find((entity: Entity) => String(entity.internalCode) === _shopId)?.name
  }

  delete(testId: string, recover: boolean) {
    console.log("deleting ", testId);   
    this.fitService.delete(testId, recover).subscribe(() => {
      // Refresh the component data instead of reloading the page
      delete this.measures[testId];
      this.searchFit(this.fitService.currentFitConfigValue.pagination);
    });
  }

  hardDelete(testId: string) {
    const mail = this.measures[testId]?.opticalShopEmail ?? null;
    console.log("hard deleting ", testId);
    this.fitService.delete(testId, false, true, mail).subscribe((response: any) => {
      if (response?.notification_status === 'failed') {
        this.hardDeleteNotificationError = response?.notification_error || 'COMMON.ERRORCONTINUE';
        utils.forceModal('#confirmationModal-hardDeleteNotification', false);
      }
      delete this.measures[testId];
      this.searchFit(this.fitService.currentFitConfigValue.pagination);
    });
  }

  /*getEntitiesByPages = (_entityId: number, _page: number, _perPage: number, _action?: number) => {
    this.ddbbUtils.getEntityFamily(_entityId, _page, _perPage).then(result => {
      if (_page === 1) {
        if (result.total > _perPage) this.ddbbUtils.forceModal('#regularProgressModal', false);
        this.finalEntities = result.data;
        this.phases = Math.ceil(result.total / _perPage);
        this.totalEntities = `${result.total.toString()} ${this.translateService.instant('COMMON.ENTITIES')}`;
      } else {
        this.finalEntities = this.finalEntities.concat(result.data)
      }
      if (_page * _perPage >= result.total) {
        this.phasesCompleted = _page;
        this.ddbbUtils.forceModal('#regularProgressModal', true);
        this.ancestorData = this.finalEntities.filter((entity: Entity) => entity.id == this.user.entityId)[0].parentEntity;
        this.user.childEntities = this.finalEntities.filter((entity: Entity) => entity.id !== this.user.entityId);
        this.fitService.currentFitConfigValue.pagination
          ? this.searchFit(this.fitService.currentFitConfigValue.pagination)
          : null;
        let storageFitFilter = JSON.parse(localStorage.getItem('fitFilter')!) as PaginationDynamoRequest
        storageFitFilter
          ? (
            this.fitService.setCurrentFitParamConfig('pagination', storageFitFilter),
            this.searchFit(storageFitFilter)
          )
          : this.searchFit();
      } else {
        this.phasesCompleted = _page;
        this.getEntitiesByPages(_entityId, _page + 1, _perPage);
      }
    })
  }*/
}
